import React, { useState } from "react";
import { downloadDatabaseBackupAdmin } from "../services/adminDatabaseBackupService";

const AdminDatabaseBackup = () => {
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");

 const downloadBackup = async () => {
 setLoading(true);
 setError("");

 try {
 const response = await downloadDatabaseBackupAdmin();

 // Extract filename from header
 const contentDisposition = response.headers["content-disposition"];
 let filename = "database_backup.sql";
 if (contentDisposition) {
 const match = contentDisposition.match(/filename="?(.+)"?/);
 if (match && match[1]) {
 filename = match[1];
 }
 }

 // Create download
 const url = window.URL.createObjectURL(response.data);
 const link = document.createElement("a");
 link.href = url;
 link.download = filename;

 document.body.appendChild(link);
 link.click();

 link.remove();
 window.URL.revokeObjectURL(url);

 } catch (err) {
 if (err.response) {
 setError(`Backup failed (status ${err.response.status})`);
 } else {
 setError("Failed to download database backup");
 }
 } finally {
 setLoading(false);
 }
 };

 return (
 <div style={styles.container}>
 <h2>Database Backup</h2>

 <p style={styles.info}>
 Click the button below to download the complete database backup.
 </p>

 <button
 onClick={downloadBackup}
 disabled={loading}
 style={{
 ...styles.button,
 backgroundColor: loading ? "#9ca3af" : "#2563eb",
 }}
 >
 {loading ? "Generating Backup..." : "Download Database Backup"}
 </button>

 {error && <p style={styles.error}>{error}</p>}
 </div>
 );
};

const styles = {
 container: {
 padding: "24px",
 maxWidth: "500px",
 background: "#fff",
 borderRadius: "8px",
 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
 },
 info: {
 marginBottom: "16px",
 color: "#555",
 },
 button: {
 padding: "12px 20px",
 color: "#fff",
 border: "none",
 borderRadius: "6px",
 cursor: "pointer",
 fontSize: "16px",
 },
 error: {
 marginTop: "12px",
 color: "red",
 },
};

export default AdminDatabaseBackup;
